import { useNavigate } from 'react-router-dom'

export function TermsContent() {
  return (
    <div className="space-y-8 text-sm text-gray-700 leading-relaxed">
      <div className="text-center space-y-1">
        <p className="text-base font-bold text-gray-900">MagoRealityMesh 클라우드 서비스 이용약관</p>
        <p className="text-gray-500">(요금 · 과금 정책 포함)</p>
      </div>

      <section>
        <h2 className="font-bold text-gray-900 mb-2">제1조 (목적)</h2>
        <p>
          본 약관은 「가이아쓰리디 ㈜」(이하 "회사")이 제공하는 MagoRealityMesh 서비스(이하 "서비스")의 이용과
          관련하여 회사와 이용자 간의 권리·의무 및 책임사항, 특히 이용요금의 산정·청구·결제 및 데이터 처리에
          관한 사항을 규정함을 목적으로 합니다.
        </p>
      </section>

      <section>
        <h2 className="font-bold text-gray-900 mb-2">제2조 (용어의 정의)</h2>
        <ol className="space-y-1.5">
          <li>① "3D 타일링 (변환)"이란 이용자가 업로드한 3차원 공간데이터를 3D Tiles 표준 형식(tileset.json, b3dm/i3dm, glTF 등)으로 변환·최적화하는 처리를 말합니다.</li>
          <li>② "저장"이란 변환 결과물(및 선택 시 원본)을 회사 클라우드에 보관하는 것을 말합니다.</li>
          <li>③ "스트리밍"이란 저장된 타일셋을 네트워크로 전송하는 것을 말합니다.</li>
          <li>④ "다운로드"란 변환 결과물을 압축본 형태로 이용자에게 전송·제공하는 것을 말합니다.</li>
          <li>⑤ "쿼터"란 각 요금제에 월 단위로 포함되는 기본 제공 한도를, "종량 과금"이란 쿼터 초과분에 단가를 적용해 부과하는 요금을 말합니다.</li>
        </ol>
      </section>

      <section>
        <h2 className="font-bold text-gray-900 mb-2">제3조 (서비스의 구성 및 요금제)</h2>
        <ol className="space-y-1.5">
          <li>① 서비스는 변환·저장·스트리밍·다운로드로 구성되며, 단일 계정 쿼터로 관리하는 SaaS 형태로 제공합니다.</li>
          <li>② 요금제는 Free(평가)·Standard·Professional·Enterprise의 4단계로 하며, 등급은 제공 기능이 아닌 사용량(쿼터)과 지원 수준으로 구분합니다.</li>
          <li>③ 계정당 응용프로그램 수 및 최종 사용자 수에는 제한을 두지 않으며, 모든 서비스 이용량은 계정 단위로 합산하여 쿼터 및 종량 과금 기준에 따라 산정됩니다.</li>
        </ol>
      </section>

      <section>
        <h2 className="font-bold text-gray-900 mb-3">제4조 (과금 항목 및 산정 기준)</h2>
        <div className="overflow-x-auto">
          <table className="w-full text-xs border border-gray-200 rounded">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 py-2 text-left border-b border-gray-200 font-semibold text-gray-700">과금 항목</th>
                <th className="px-3 py-2 text-left border-b border-gray-200 font-semibold text-gray-700">과금 단위</th>
                <th className="px-3 py-2 text-left border-b border-gray-200 font-semibold text-gray-700">산정 기준</th>
                <th className="px-3 py-2 text-left border-b border-gray-200 font-semibold text-gray-700">비고</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              <tr><td className="px-3 py-2">변환</td><td className="px-3 py-2">입력 GB</td><td className="px-3 py-2">업로드 원본 입력 용량</td><td className="px-3 py-2 text-gray-500">포맷별 가중 가능</td></tr>
              <tr><td className="px-3 py-2">저장</td><td className="px-3 py-2">GB·월</td><td className="px-3 py-2">월 일할 평균 저장 용량</td><td className="px-3 py-2 text-gray-500">원본 보관 시 포함</td></tr>
              <tr><td className="px-3 py-2">스트리밍</td><td className="px-3 py-2">전송 GB</td><td className="px-3 py-2">월 누적 전송 트래픽</td><td className="px-3 py-2 text-gray-500">주요 비용 동인</td></tr>
              <tr><td className="px-3 py-2">다운로드</td><td className="px-3 py-2">결과 GB</td><td className="px-3 py-2">압축본 생성·전송</td><td className="px-3 py-2 text-gray-500">종량 부가서비스</td></tr>
            </tbody>
          </table>
        </div>
      </section>

      <section>
        <h2 className="font-bold text-gray-900 mb-3">제5조 (요금제 및 이용요금)</h2>
        <p className="mb-3">각 요금제의 월 기본요금 및 포함 쿼터는 다음과 같습니다(부가가치세 별도, 단위: 원/월).</p>
        <div className="overflow-x-auto">
          <table className="w-full text-xs border border-gray-200 rounded">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 py-2 text-left border-b border-gray-200 font-semibold text-gray-700">구분</th>
                <th className="px-3 py-2 text-center border-b border-gray-200 font-semibold text-gray-700">Free/평가</th>
                <th className="px-3 py-2 text-center border-b border-gray-200 font-semibold text-gray-700">Standard</th>
                <th className="px-3 py-2 text-center border-b border-gray-200 font-semibold text-gray-700">Professional</th>
                <th className="px-3 py-2 text-center border-b border-gray-200 font-semibold text-gray-700">Enterprise</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              <tr>
                <td className="px-3 py-2 font-medium">월 기본요금</td>
                <td className="px-3 py-2 text-center">무료</td>
                <td className="px-3 py-2 text-center">99,000</td>
                <td className="px-3 py-2 text-center">590,000</td>
                <td className="px-3 py-2 text-center">협의</td>
              </tr>
              <tr>
                <td className="px-3 py-2 font-medium">변환(GB/월)</td>
                <td className="px-3 py-2 text-center">5</td>
                <td className="px-3 py-2 text-center">50</td>
                <td className="px-3 py-2 text-center">200</td>
                <td className="px-3 py-2 text-center">협의</td>
              </tr>
              <tr>
                <td className="px-3 py-2 font-medium">저장(GB)</td>
                <td className="px-3 py-2 text-center">5</td>
                <td className="px-3 py-2 text-center">100</td>
                <td className="px-3 py-2 text-center">500</td>
                <td className="px-3 py-2 text-center">협의</td>
              </tr>
              <tr>
                <td className="px-3 py-2 font-medium">스트리밍(GB/월)</td>
                <td className="px-3 py-2 text-center">15*</td>
                <td className="px-3 py-2 text-center">200</td>
                <td className="px-3 py-2 text-center">1,000</td>
                <td className="px-3 py-2 text-center">협의</td>
              </tr>
              <tr>
                <td className="px-3 py-2 font-medium">다운로드</td>
                <td className="px-3 py-2 text-center">미제공</td>
                <td className="px-3 py-2 text-center">종량</td>
                <td className="px-3 py-2 text-center">종량</td>
                <td className="px-3 py-2 text-center">협의</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mt-2 space-y-1 text-xs text-gray-500">
          <p>※ 변환, 저장 용량은 누적합산량으로 한다.</p>
          <p>※ 변환, 스트리밍 및 다운로드 사용량이 포함 쿼터를 초과하는 경우 제6조의 종량 과금 기준이 적용됩니다.</p>
          <p>※ Enterprise 요금제의 쿼터 및 지원 수준은 별도 계약에 따릅니다.</p>
        </div>
      </section>

      <section>
        <h2 className="font-bold text-gray-900 mb-3">제6조 (쿼터 초과 및 다운로드 종량 과금)</h2>
        <ol className="space-y-3">
          <li>
            <p className="mb-2">① 쿼터 초과분 및 다운로드에 대하여 다음 종량 단가를 익월 청구분에 합산합니다(부가세 별도).</p>
            <div className="overflow-x-auto">
              <table className="w-full text-xs border border-gray-200 rounded">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-3 py-2 text-left border-b border-gray-200 font-semibold text-gray-700">자원</th>
                    <th className="px-3 py-2 text-left border-b border-gray-200 font-semibold text-gray-700">단위</th>
                    <th className="px-3 py-2 text-right border-b border-gray-200 font-semibold text-gray-700">종량 단가</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  <tr><td className="px-3 py-2">변환</td><td className="px-3 py-2">원/입력 GB</td><td className="px-3 py-2 text-right">700</td></tr>
                  <tr><td className="px-3 py-2">저장</td><td className="px-3 py-2">원/GB·월</td><td className="px-3 py-2 text-right">120</td></tr>
                  <tr><td className="px-3 py-2">스트리밍</td><td className="px-3 py-2">원/전송 GB</td><td className="px-3 py-2 text-right">300</td></tr>
                  <tr><td className="px-3 py-2">다운로드(압축본)</td><td className="px-3 py-2">원/결과 GB</td><td className="px-3 py-2 text-right">600</td></tr>
                </tbody>
              </table>
            </div>
          </li>
          <li>② 이용자는 쿼터 초과 시 종량 자동 과금 또는 사용 제한 중 하나를 선택할 수 있으며, 별도 설정이 없는 경우 종량 자동 과금이 적용됩니다.</li>
          <li>③ 저장 사용량은 월 총 누적 저장량이며, 다운로드 사용량은 다운로드 시 생성된 압축 파일 크기를 기준으로 산정합니다.</li>
        </ol>
      </section>

      <section>
        <h2 className="font-bold text-gray-900 mb-2">제7조 (할인)</h2>
        <ol className="space-y-1.5">
          <li>① 연간 약정 결제 시 월 정가의 10개월분 요금으로 12개월간 서비스를 이용할 수 있습니다.</li>
          <li>② 교육기관, 비영리기관 및 공공기관에 대하여 회사가 별도로 정한 할인 정책을 적용할 수 있습니다.</li>
          <li>③ 할인은 신청 시 제출한 기관 목적에 부합하는 이용에 한하며, 목적 외 사용이 확인되는 경우 회사는 할인 적용을 취소하고 할인받은 금액 상당의 차액을 청구할 수 있습니다(소급 적용).</li>
        </ol>
      </section>

      <section>
        <h2 className="font-bold text-gray-900 mb-2">제8조 (무료·평가판 계정)</h2>
        <ol className="space-y-1.5">
          <li>① Free 등급은 기능 평가 및 테스트 목적으로 제공되며, 변환 5GB, 저장 5GB, 스트리밍 15GB/월의 범위 내에서 이용할 수 있습니다. 다운로드 기능은 제공되지 않습니다.</li>
          <li>② 회사는 무료 계정의 남용 방지를 위해 이용을 제한하거나 상업적 이용 확인 시 유료 전환을 요청할 수 있습니다.</li>
          <li>③ 회사는 일정 기간 이상 사용되지 않은 무료 계정 및 데이터를 정리할 수 있으며, 필요한 경우 사전에 안내합니다.</li>
        </ol>
      </section>

      <section>
        <h2 className="font-bold text-gray-900 mb-2">제9조 (결제 및 청구)</h2>
        <ol className="space-y-1.5">
          <li>① 모든 이용요금에는 부가가치세가 별도로 부과됩니다.</li>
          <li>② 월 기본요금은 선불로 청구하며, 종량 과금 및 다운로드 요금은 해당 월 사용량을 기준으로 익월에 후불 청구합니다.</li>
          <li>③ 결제수단은 신용카드, 체크카드 및 계좌이체를 지원하며, 법인 이용자에 대해서는 세금계산서를 발행할 수 있습니다.</li>
          <li>④ 이용자가 정기결제를 선택한 경우 회사는 등록된 결제수단을 통하여 이용요금을 자동 청구할 수 있습니다.</li>
          <li>⑤ 이용요금이 납부되지 않는 경우 회사는 서비스 이용을 제한하거나 계정을 정지할 수 있습니다.</li>
        </ol>
      </section>

      <section>
        <h2 className="font-bold text-gray-900 mb-2">제10조 (요금의 변경)</h2>
        <ol className="space-y-1.5">
          <li>① 회사는 합리적 사유가 있는 경우 이용요금 및 종량 단가를 변경할 수 있습니다.</li>
          <li>② 요금 인상 시 적용일로부터 최소 30일 전에 서비스 내 공지 및 이메일로 고지하며, 기 체결된 연간 약정 요금은 약정 기간 동안 변경되지 않습니다.</li>
        </ol>
      </section>

      <section>
        <h2 className="font-bold text-gray-900 mb-2">제11조 (변환 실패 시 처리 및 기술지원)</h2>
        <ol className="space-y-1.5">
          <li>① 회사는 변환 실패 발생 시 영업일 기준 48시간 이내에 실패 원인을 이용자에게 통지합니다.</li>
          <li>② 기능상의 결함 등 회사의 귀책으로 변환이 실패한 경우, 회사는 해당 변환 작업에 대한 과금을 취소하고 무상 재처리를 제공하며, 재처리가 불가능한 경우 해당 작업에 상응하는 서비스 크레딧을 제공할 수 있습니다.</li>
          <li>③ 이용자 데이터의 손상, 형식 오류 또는 규격 위반 등 이용자 귀책사유로 변환이 실패한 경우에는 해당 작업에 대한 과금이 발생할 수 있습니다.</li>
        </ol>
      </section>

      <section>
        <h2 className="font-bold text-gray-900 mb-2">제12조 (이용요금 미납 및 서비스 제한)</h2>
        <ol className="space-y-1.5">
          <li>① 이용자가 기일까지 요금을 납부하지 않는 경우, 회사는 통지 후 서비스(특히 스트리밍) 이용을 제한할 수 있습니다.</li>
          <li>② 미납 상태가 30일 이상 지속되는 경우 회사는 계약을 해지할 수 있으며, 데이터는 제15조의 유예·통지 절차를 거쳐 삭제합니다.</li>
        </ol>
      </section>

      <section>
        <h2 className="font-bold text-gray-900 mb-2">제13조 (청약철회 및 환불)</h2>
        <ol className="space-y-1.5">
          <li>① 월정가의 경우 다음 주기 전 해지로 갱신을 중단할 수 있으며, 이미 결제된 당월 기본요금은 원칙적으로 환불되지 않습니다.</li>
          <li>② 연납의 경우 중도 해지 시 사용 기간을 월정가(할인 미적용)로 정산한 후 잔액을 환불합니다.</li>
          <li>
            ③ 다음 각 호의 사유가 있는 경우 회사는 이용요금의 전부 또는 일부를 환불할 수 있습니다.
            <ul className="mt-1.5 ml-4 space-y-1 list-disc">
              <li>회사의 기능상 결함으로 인해 변환 서비스를 정상적으로 이용할 수 없는 경우</li>
              <li>회사가 사전에 고지하지 않은 기술적 제한으로 인해 서비스 이용이 불가능한 경우</li>
              <li>결제 후 변환, 저장 또는 스트리밍 서비스를 전혀 이용하지 않은 상태에서 30일 이내 환불을 요청한 경우</li>
            </ul>
          </li>
        </ol>
      </section>

      <section>
        <h2 className="font-bold text-gray-900 mb-2">제14조 (재가입 시 비용 정산)</h2>
        <ol className="space-y-1.5">
          <li>① 이용자가 서비스를 해지한 후 데이터 보관기간 내에 재가입하는 경우, 회사는 해당 보관기간 동안 발생한 저장 비용을 정산하여 청구할 수 있습니다.</li>
          <li>② 데이터 삭제 후 재가입하는 경우 신규 가입으로 처리합니다.</li>
        </ol>
      </section>

      <section>
        <h2 className="font-bold text-gray-900 mb-2">제15조 (데이터의 보관·삭제 처리)</h2>
        <ol className="space-y-1.5">
          <li>① 이용자가 업로드한 원본 데이터 및 변환 결과물의 소유권은 이용자에게 있습니다.</li>
          <li>② 이용자는 회사가 서비스 제공을 위하여 데이터를 저장, 백업, 전송, 처리 및 삭제하는 것에 동의합니다.</li>
          <li>③ 원본 데이터 보관은 선택 기능으로 저장 용량에 따라 과금되며, 회사는 원본만 선택 삭제하는 기능과 원본 데이터 다운로드(반출) 기능을 제공합니다.</li>
          <li>④ 계약 종료 또는 해지 시 회사는 30일간 데이터를 보관하며, 이용자는 해당 기간 내 데이터 반출을 요청할 수 있습니다. 유예기간 경과 후 데이터는 복구가 불가능한 방식으로 삭제됩니다.</li>
          <li>⑤ 이용자는 업로드 데이터에 관련 법령상 보호가 필요한 개인정보·민감정보 또는 보안 대상 정보가 포함되지 않도록 하여야 하며, 이를 위반하여 발생하는 책임은 이용자에게 있습니다.</li>
        </ol>
      </section>

      <section>
        <h2 className="font-bold text-gray-900 mb-2">제16조 (서비스 수준 및 손해배상)</h2>
        <ol className="space-y-1.5">
          <li>① 회사는 유료 요금제에 대하여 월간 가용성 목표(예: 99.5% 이상)를 정하고, 미충족 시 해당 월 기본요금의 일정 비율을 서비스 크레딧으로 보상합니다.</li>
          <li>② 회사의 손해배상 책임은 관련 법령이 허용하는 범위 내에서 직전 12개월간 이용자가 지급한 요금 총액을 한도로 합니다.</li>
        </ol>
      </section>

      <section>
        <h2 className="font-bold text-gray-900 mb-2">제17조 (지식재산권)</h2>
        <ol className="space-y-1.5">
          <li>① 서비스 및 이를 구성하는 소프트웨어·문서에 대한 지식재산권은 회사에 귀속됩니다.</li>
          <li>② 이용자는 회사의 사전 동의 없이 서비스를 복제, 수정, 역설계, 재배포 또는 상업적으로 이용할 수 없습니다.</li>
        </ol>
      </section>

      <section>
        <h2 className="font-bold text-gray-900 mb-2">제18조 (면책)</h2>
        <p>천재지변, 통신사업자·클라우드 인프라 제공사의 장애 등 회사의 합리적 통제를 벗어난 사유로 인한 서비스 중단에 대하여 회사는 책임을 지지 않습니다. 다만 회사는 신속한 복구를 위해 합리적인 노력을 다합니다.</p>
      </section>

      <section className="border-t border-gray-200 pt-6">
        <h2 className="font-bold text-gray-900 mb-2">부칙</h2>
        <p>본 약관은 2026년 8월 1일부터 시행합니다.</p>
      </section>
    </div>
  )
}

export default function TermsPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white rounded-xl shadow p-8">
          <div className="flex items-center justify-between mb-8 pb-4 border-b border-gray-200">
            <div>
              <h1 className="text-xl font-bold text-gray-900">서비스 이용약관</h1>
              <p className="text-xs text-gray-400 mt-0.5">가이아쓰리디 ㈜ · MagoRealityMesh</p>
            </div>
            <button
              onClick={() => navigate(-1)}
              className="text-sm text-primary-600 hover:underline"
            >
              ← 돌아가기
            </button>
          </div>
          <TermsContent />
        </div>
      </div>
    </div>
  )
}
